import React from 'react'
import './About.css'

const About = () => {
  return (
    <div className="about-us-container">
      <h1>About Us</h1>
      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. A, illum dolorem vero quia, vel voluptas asperiores sequi quis, dolorum numquam esse error nisi deserunt maiores consectetur tempora impedit provident? Totam qui tempora eligendi nulla. Unde quas nisi error quo, aperiam iure facere tempore quae optio iste.</p>
    </div>
  )
}

export default About